export default {"src":"/org/_next/static/media/arrow-right-white.29981e10.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};